import { RequestQueryBuilder } from "@nestjsx/crud-request";
import { setHours, setMinutes } from "date-fns";
import format from "date-fns/format";
import parse from "date-fns/parse";
import qs from "query-string";

import { IRange } from "../../../core/models";

export interface ISingleClientHistoryFilter {
  createdDateRange?: IRange<Date>;
  clientId: string;
}

export function singleClientHistoryFilterToQueryParams(filter: ISingleClientHistoryFilter): string {
  const qb = RequestQueryBuilder.create();

  if (filter.createdDateRange?.from) {
    qb.setFilter({
      field: "createdDate",
      operator: "$gte",
      value: format(setMinutes(setHours(filter.createdDateRange?.from, 0), 0), "yyyy-MM-dd HH:mm"),
    });
  }

  if (filter.createdDateRange?.to) {
    qb.setFilter({
      field: "createdDate",
      operator: "$lte",
      value: format(setMinutes(setHours(filter.createdDateRange?.to, 23), 59), "yyyy-MM-dd HH:mm"),
    });
  }

  qb.setFilter({
    field: "client",
    operator: "$eq",
    value: filter.clientId,
  });

  qb.sortBy({ field: "id", order: "DESC" });

  return qb.query(false);
}

export function singleClientHistoryQueryParamsToFilter(
  queryString: string,
  clientId: string,
): ISingleClientHistoryFilter {
  const queryParams = qs.parse(queryString);
  const filter: ISingleClientHistoryFilter = {
    clientId,
  };

  Object.keys(queryParams).forEach((key) => {
    if (key.includes("filter")) {
      const query = queryParams[key]?.toString();

      if (query) {
        const parsed = query.split("||");
        const filterKey = parsed[0];
        const condition = parsed[1];
        const filterValue = parsed[2];

        if (filterKey === "createdDate" && condition === "$gte") {
          filter.createdDateRange = {
            from: new Date(filterValue),
            to: filter.createdDateRange?.to,
          };
        } else if (filterKey === "createdDate" && condition === "$lte") {
          filter.createdDateRange = {
            to: new Date(filterValue),
            from: filter.createdDateRange?.from,
          };
        }
      }
    }
  });

  return filter;
}

export interface IClientHistoryFilter {
  createdDate?: Date;
}

export function clientHistoryFilterToQueryParams(filter: IClientHistoryFilter): string {
  if (!filter.createdDate) {
    return "";
  }

  return qs.stringify({
    createdDate: format(filter.createdDate, "yyyy-MM-dd"),
  });
}

export function clientHistoryQueryParamsToFilter(queryString: string): IClientHistoryFilter {
  const queryParams = qs.parse(queryString);
  const filter: IClientHistoryFilter = {};

  if (queryParams.createdDate) {
    filter.createdDate = parse(queryParams.createdDate?.toString(), "yyyy-MM-dd", new Date());
  }

  return filter;
}
